(function () {
    'use strict';
  
    var FIELD_SELECTORS = [
      '.mw-option.engraving-field',
      '.mw-option[class*="engraving-area-"]',
      '.mw-option[class*="engraving-size-"]',
      '.mw-option[class*="engraving-mm-"]',
      '.mw-option[class*="engraving-dimensions-"]',
      '.mw-option[class*="engraving-length-"]',
      '.mw-option[class*="engraving-long-"]'
    ];
    var FIELD_SELECTOR = FIELD_SELECTORS.join(', ');
    var APO_OPTION_SELECTOR = '.mw-option';
    var PRODUCT_FORM_SELECTOR = 'form[action*="/cart/add"]';
    var CONTROL_SELECTOR = '.mw-option__control';
    var FIELD_TEXT_CONTROL_SELECTOR = FIELD_SELECTORS.map(function (selector) {
      return selector + ' textarea' + CONTROL_SELECTOR + ', ' +
        selector + ' input' + CONTROL_SELECTOR;
    }).join(', ');
    var CHAR_LABEL_SELECTOR = '.char-label';
    var PREVIEW_CLASS = 'mf-engraving-preview';
    var PREVIEW_LABEL_CLASS = 'mf-engraving-preview-label';
    var PREVIEW_TEXT_CLASS = 'mf-engraving-preview__text';
    var NEWLINE_MARKER = '¦';
    var HIDDEN_PROPERTY_PREFIX = '_Line breaks - ';
    var CART_ATTR_PREFIX = 'mf_lb:';
    var CART_EDIT_STORAGE_KEY = 'mfCartEditPayload';
    var CART_EDIT_REPLACEMENT_STORAGE_KEY = 'mfCartEditReplacement';
    var CART_EDIT_MAX_AGE_MS = 30 * 60 * 1000;
    var CART_EDIT_CLEAR_DELAY_MS = 8000;
    var CART_EDIT_REAPPLY_INTERVAL_MS = 250;
    var CART_EDIT_REAPPLY_DURATION_MS = 7000;
    var CART_EDIT_UPLOAD_PROPERTY = /^Upload your prints(?: \((\d+)\))?$/;
    var CART_EDIT_UPLOAD_NOTE_CLASS = 'mf-cart-edit-uploads';
    var STYLE_ID = 'mf-engraving-preview-styles';
    var WINDOWS_PLATFORM_CLASS = 'mf-engraving-platform-windows';
    var STATE_KEY = '__mfEngravingPreview';
    var OBSERVER_DEBOUNCE_MS = 120;
    var SUBMIT_RESTORE_MS = 1500;
    var TEXTAREA_INTERACTION_GRACE_MS = 3000;
    var TEXTAREA_AUTO_GROW_MAX_HEIGHT = 260;
    var MIN_FONT_SIZE = 10;
    var MOBILE_MIN_FONT_SIZE = 12;
    var MAX_FONT_SIZE = 16;
    var MOBILE_MAX_FONT_SIZE = 18;
    var FONT_SIZE_LINE_SCALE = 1.2;
    var FONT_SIZE_BASE_LINES = 5;
    var PREVIEW_LONG_RATIO_WIDTH = 'clamp(420px,60%,720px)';
    var PREVIEW_MIN_DIMENSION_HEIGHT = 48;
    var PREVIEW_FALLBACK_DIMENSION_WIDTH = 420;
    var MOBILE_PREVIEW_FALLBACK_DIMENSION_WIDTH = 320;
    var MOBILE_WIDTH = 640;
    var TEMP_DISABLE_TEXTAREA_ENHANCEMENTS = false;
    var FONT_OPTION_LABEL = 'font';
    var FONT_PREVIEW_CLASS_PREFIX = PREVIEW_TEXT_CLASS + '--font-';
    var FONT_PREVIEW_STYLE_COUNT = 6;
    var FONT_PREVIEW_STYLES = [
      { name: 'Foundry', file: 'Foundry.woff2', fallback: 'serif', windowsYOffset: '0.12em' },
      { name: 'Verse', file: 'Verse.woff2', fallback: 'serif' },
      { name: 'Studio', file: 'Studio.woff2', fallback: 'sans-serif' },
      { name: 'Painter', file: 'Painter.woff2', fallback: 'cursive' },
      { name: 'Heirloom', file: 'Heirloom.woff2', fallback: 'serif' },
      { name: 'Press', file: 'Press.woff2', fallback: 'serif' }
    ];
  
    var state = window[STATE_KEY] || {
      observerInstalled: false,
      resizeInstalled: false
    };
  
    window[STATE_KEY] = state;
  
    function getScriptAssetBaseUrl() {
      var scripts = document.getElementsByTagName('script');
      var currentScript = document.currentScript;
      var script;
      var src;
      var index;
      var i;
  
      if (currentScript && currentScript.src) {
        index = currentScript.src.indexOf('apo-engraving-preview.js');
  
        if (index !== -1) {
          return currentScript.src.slice(0, index);
        }
      }
  
      for (i = scripts.length - 1; i >= 0; i -= 1) {
        script = scripts[i];
        src = script && script.src ? script.src : '';
        index = src.indexOf('apo-engraving-preview.js');
  
        if (index !== -1) {
          return src.slice(0, index);
        }
      }
  
      return '';
    }
  
    function escapeCssString(value) {
      return String(value || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    }
  
    function getAssetUrl(fileName) {
      return getScriptAssetBaseUrl() + fileName;
    }
  
    function getFontFamilyName(style) {
      return 'MF Engraving ' + style.name;
    }
  
    function getFontFaceStyles() {
      return FONT_PREVIEW_STYLES.map(function (style) {
        return '@font-face{font-family:"' + escapeCssString(getFontFamilyName(style)) + '";' +
          'src:url("' + escapeCssString(getAssetUrl(style.file)) + '") format("woff2");' +
          'font-weight:400;font-style:normal;font-display:swap;}';
      }).join('');
    }
  
    function getPreviewFontStyles() {
      return FONT_PREVIEW_STYLES.map(function (style, index) {
        var previewClass = getFontPreviewClass(index + 1);
        var fontRule = '.' + PREVIEW_CLASS + ' .' + previewClass + '{font-family:"' +
          escapeCssString(getFontFamilyName(style)) + '",' + style.fallback + ';}';
        var windowsOffsetRule = style.windowsYOffset
          ? '.' + WINDOWS_PLATFORM_CLASS + ' .' + PREVIEW_CLASS + ' .' + previewClass +
            '{transform:translateY(' + style.windowsYOffset + ');}'
          : '';
  
        return fontRule + windowsOffsetRule;
      }).join('');
    }
  
    function getFieldContainmentStyles() {
      var selectors = [];
  
      FIELD_SELECTORS.forEach(function (selector) {
        selectors.push(selector);
        selectors.push(selector + ' .mw-stack__item');
        selectors.push(selector + ' .mw-option__container');
      });
  
      return selectors.join(',') + '{min-width:0;max-width:100%;}';
    }
  
    function addStyles() {
      if (document.getElementById(STYLE_ID)) {
        return;
      }
  
      var style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent =
        getFontFaceStyles() +
        getFieldContainmentStyles() +
        '.' + PREVIEW_CLASS + '{clear:both;box-sizing:border-box;width:clamp(360px,40%,520px);inline-size:clamp(360px,40%,520px);max-width:100%;max-inline-size:100%;min-width:0;min-inline-size:0;contain:inline-size;margin:8px auto 16px;padding:14px;height:124px;height:clamp(112px,15vw,136px);max-height:136px;border:1px solid #d8d8d8;background:#fff;display:flex;align-items:center;justify-content:flex-start;overflow:hidden;overflow-x:auto;overflow-y:hidden;overscroll-behavior-x:contain;-webkit-overflow-scrolling:touch;}' +
        '.' + PREVIEW_CLASS + ' .' + PREVIEW_TEXT_CLASS + '{display:inline-block;flex:none;width:auto;inline-size:max-content;min-width:100%;min-inline-size:100%;max-width:none;text-align:center;white-space:pre;line-height:1.22;font-size:' + MAX_FONT_SIZE + 'px;color:#18233f;}' +
        getPreviewFontStyles() +
        '.' + PREVIEW_CLASS + '[data-empty="true"] .' + PREVIEW_TEXT_CLASS + '{opacity:.48;font-size:16px;color:#8a8a8c;white-space:normal;width:100%;inline-size:100%;min-width:0;min-inline-size:0;}' +
        '.' + PREVIEW_LABEL_CLASS + '{clear:both;margin:10px 0 6px;font-size:13px;line-height:1.35;color:#50545c;}' +
        '.' + PREVIEW_LABEL_CLASS + ' strong{font-weight:600;color:#18233f;}' +
        '.' + CART_EDIT_UPLOAD_NOTE_CLASS + '{margin:8px 0 0;font-size:13px;line-height:1.4;color:#50545c;}' +
        '.' + CART_EDIT_UPLOAD_NOTE_CLASS + ' a{color:#18233f;text-decoration:underline;}' +
        '@media (max-width:' + MOBILE_WIDTH + 'px){.' + PREVIEW_CLASS + '{width:100%;inline-size:100%;max-width:100%;max-inline-size:100%;height:92px;max-height:92px;padding:10px;margin:8px 0 14px;}.' + PREVIEW_LABEL_CLASS + '{font-size:14px;}}';
      document.head.appendChild(style);
    }
  
    function getClassName(element) {
      return element && typeof element.className === 'string' ? element.className : '';
    }
  
    function parseDimensionValue(value) {
      var parsed = parseFloat(String(value || '').replace('p', '.'));
      return isNaN(parsed) || parsed <= 0 ? 0 : parsed;
    }
  
    function parseEngravingDimensions(className) {
      var compactMatch = className.match(/\b(?:engraving-)?(?:area|size|mm|dimensions)-(\d+(?:p\d+)?)(?:mm)?[x-](\d+(?:p\d+)?)(?:mm)?\b/i);
      var lengthMatch;
      var heightMatch;
      var length;
      var height;
  
      if (compactMatch) {
        length = parseDimensionValue(compactMatch[1]);
        height = parseDimensionValue(compactMatch[2]);
      } else {
        lengthMatch = className.match(/\b(?:engraving-)?(?:length|long)-(\d+(?:p\d+)?)(?:mm)?\b/i);
        heightMatch = className.match(/\b(?:engraving-)?(?:height|wide|width|short)-(\d+(?:p\d+)?)(?:mm)?\b/i);
        length = lengthMatch ? parseDimensionValue(lengthMatch[1]) : 0;
        height = heightMatch ? parseDimensionValue(heightMatch[1]) : 0;
      }
  
      return length && height
        ? {
          lengthMm: length,
          heightMm: height
        }
        : null;
    }
  
    function parseConfig(wrapper) {
      var className = getClassName(wrapper);
      var linesMatch = className.match(/\blines-(\d+)\b/);
      var charsMatch = className.match(/\bchars-(\d+)\b/);
      var dimensions = parseEngravingDimensions(className);
  
      return {
        maxLines: linesMatch ? Math.max(parseInt(linesMatch[1], 10), 1) : 5,
        maxCharsPerLine: charsMatch ? Math.max(parseInt(charsMatch[1], 10), 1) : 40,
        lengthMm: dimensions ? dimensions.lengthMm : 0,
        heightMm: dimensions ? dimensions.heightMm : 0
      };
    }
  
    function makeEvent(type) {
      var event;
  
      if (typeof Event === 'function') {
        return new Event(type, { bubbles: true });
      }
  
      event = document.createEvent('Event');
      event.initEvent(type, true, false);
      return event;
    }
  
    function dispatchControlEvents(control) {
      control.dispatchEvent(makeEvent('input'));
      control.dispatchEvent(makeEvent('change'));
    }
  
    function requestFrame(callback) {
      if (typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(callback);
        return;
      }
  
      window.setTimeout(callback, 16);
    }
  
    function isWindowsPlatform() {
      var nav = window.navigator || {};
      var platform = nav.userAgentData && nav.userAgentData.platform
        ? nav.userAgentData.platform
        : nav.platform || '';
      var userAgent = nav.userAgent || '';
  
      return /win/i.test(platform) || /windows/i.test(userAgent);
    }
  
    function applyPlatformClass() {
      var root = document.documentElement;
  
      if (root && root.classList && isWindowsPlatform()) {
        root.classList.add(WINDOWS_PLATFORM_CLASS);
      }
    }
  
    function isMobileWidth() {
      if (typeof window.matchMedia === 'function') {
        return window.matchMedia('(max-width: ' + MOBILE_WIDTH + 'px)').matches;
      }
  
      return window.innerWidth <= MOBILE_WIDTH;
    }
  
    function getPreviewLineFontSizeMultiplier(config) {
      var maxLines = config && config.maxLines ? config.maxLines : 5;
      var steps = Math.max(FONT_SIZE_BASE_LINES - maxLines, 0);
      var multiplier = 1;
      var i;
  
      for (i = 0; i < steps; i += 1) {
        multiplier *= FONT_SIZE_LINE_SCALE;
      }
  
      return multiplier;
    }
  
    function getPreviewMaxFontSize(config) {
      return Math.round((isMobileWidth() ? MOBILE_MAX_FONT_SIZE : MAX_FONT_SIZE) *
        getPreviewLineFontSizeMultiplier(config));
    }
  
    function getPreviewMinFontSize() {
      return isMobileWidth() ? MOBILE_MIN_FONT_SIZE : MIN_FONT_SIZE;
    }
  
    function getAutoGrowMaxHeight() {
      return isMobileWidth() ? TEXTAREA_AUTO_GROW_MAX_HEIGHT : 0;
    }
  
    function toPixels(value) {
      var parsed = parseFloat(value);
      return isNaN(parsed) ? 0 : parsed;
    }
  
    function elementMatches(element, selector) {
      var matches = element && (
        element.matches ||
        element.msMatchesSelector ||
        element.webkitMatchesSelector
      );
  
      return !!matches && matches.call(element, selector);
    }
  
    function closestElement(element, selector) {
      var target = element;
  
      while (target && target.nodeType === 1) {
        if (elementMatches(target, selector)) {
          return target;
        }
  
        target = target.parentNode;
      }
  
      return null;
    }
  
    function normalizeLineBreaks(value) {
      return String(value || '').replace(/\r\n?/g, '\n');
    }
  
    function toEditingValue(value) {
      return normalizeLineBreaks(value).split(NEWLINE_MARKER).join('\n');
    }
  
    function isTextareaEnhancementDisabled(control) {
      return TEMP_DISABLE_TEXTAREA_ENHANCEMENTS &&
        control &&
        control.tagName === 'TEXTAREA';
    }
  
    function getVisibleCharacterLimit(config) {
      return config.maxLines * config.maxCharsPerLine;
    }
  
    function isFocusedControl(control) {
      return control && document.activeElement === control;
    }
  
    function isTextareaControl(control) {
      return control && control.tagName === 'TEXTAREA';
    }
  
    function markTextareaInteraction(control) {
      if (!isTextareaControl(control)) {
        return;
      }
  
      state.textareaInteractionControl = control;
      state.textareaInteractionUntil = Date.now() + TEXTAREA_INTERACTION_GRACE_MS;
    }
  
    function clearTextareaInteraction(control) {
      if (control && state.textareaInteractionControl !== control) {
        return;
      }
  
      state.textareaInteractionControl = null;
      state.textareaInteractionUntil = 0;
    }
  
    function isTextareaInteractionActive(control) {
      return isTextareaControl(control) &&
        (
          isFocusedControl(control) ||
          (
            state.textareaInteractionControl === control &&
            Date.now() < (state.textareaInteractionUntil || 0)
          )
        );
    }
  
    function isAnyTextControlInteractionActive() {
      return elementMatches(document.activeElement, FIELD_TEXT_CONTROL_SELECTOR) ||
        Date.now() < (state.textareaInteractionUntil || 0);
    }
  
    function getViewportHeight() {
      return window.visualViewport && window.visualViewport.height
        ? window.visualViewport.height
        : (window.innerHeight || document.documentElement.clientHeight || 0);
    }
  
    function isElementVerticallyVisible(element) {
      var rect = element && typeof element.getBoundingClientRect === 'function'
        ? element.getBoundingClientRect()
        : null;
  
      return !!rect && rect.bottom > 0 && rect.top < getViewportHeight();
    }
  
    function releaseFocusedTextareaIfOffscreen() {
      var active = document.activeElement;
  
      if (
        !isMobileWidth() ||
        !isTextareaControl(active) ||
        !elementMatches(active, FIELD_TEXT_CONTROL_SELECTOR) ||
        isElementVerticallyVisible(active)
      ) {
        return;
      }
  
      clearTextareaInteraction(active);
  
      if (typeof active.blur === 'function') {
        active.blur();
      }
    }
  
    function limitEditingValue(value, config) {
      var text = toEditingValue(value);
      var layoutLine = 1;
      var charsOnLayoutLine = 0;
      var output = '';
      var character;
      var i;
  
      // Track wrapped engraving lines without adding those line breaks to the textarea.
      for (i = 0; i < text.length; i += 1) {
        character = text.charAt(i);
  
        if (character === '\n') {
          if (layoutLine >= config.maxLines) {
            break;
          }
  
          output += character;
          layoutLine += 1;
          charsOnLayoutLine = 0;
          continue;
        }
  
        if (charsOnLayoutLine >= config.maxCharsPerLine) {
          layoutLine += 1;
          charsOnLayoutLine = 0;
        }
  
        if (layoutLine > config.maxLines) {
          break;
        }
  
        output += character;
        charsOnLayoutLine += 1;
      }
  
      return output;
    }
  
    function getRemainingCharacterCount(value, config) {
      var text = limitEditingValue(value, config);
      var layoutLine = 1;
      var charsOnLayoutLine = 0;
      var character;
      var i;
  
      for (i = 0; i < text.length; i += 1) {
        character = text.charAt(i);
  
        if (character === '\n') {
          layoutLine += 1;
          charsOnLayoutLine = 0;
          continue;
        }
  
        if (charsOnLayoutLine >= config.maxCharsPerLine) {
          layoutLine += 1;
          charsOnLayoutLine = 0;
        }
  
        charsOnLayoutLine += 1;
      }
  
      return Math.max(
        ((config.maxLines - layoutLine) * config.maxCharsPerLine) +
          (config.maxCharsPerLine - charsOnLayoutLine),
        0
      );
    }
  
    function growTextareaAfterInput(control) {
      var maxHeight = getAutoGrowMaxHeight();
      var currentHeight;
      var nextHeight;
      var shouldUseInternalScroll = !isMobileWidth();
  
      if (!isTextareaControl(control)) {
        return;
      }
  
      if (!maxHeight) {
        control.style.height = '';
        control.style.overflowY = '';
        return;
      }
  
      currentHeight = control.offsetHeight || toPixels(window.getComputedStyle(control).height);
      control.style.height = 'auto';
      nextHeight = shouldUseInternalScroll
        ? Math.max(currentHeight, Math.min(control.scrollHeight, maxHeight))
        : Math.max(currentHeight, control.scrollHeight);
      control.style.height = nextHeight + 'px';
      control.style.overflowY = shouldUseInternalScroll && control.scrollHeight > nextHeight ? 'auto' : 'hidden';
    }
  
    function getControlMaxLength(config) {
      return getVisibleCharacterLimit(config) + Math.max(config.maxLines - 1, 0);
    }
  
    function syncControlMaxLength(control, config) {
      var currentMaxLength;
      var visibleLimit;
      var requiredMaxLength;
  
      if (!control || control.tagName !== 'TEXTAREA' || config.maxLines <= 1) {
        return;
      }
  
      currentMaxLength = control.maxLength;
      visibleLimit = getVisibleCharacterLimit(config);
      requiredMaxLength = getControlMaxLength(config);
  
      if (
        currentMaxLength > 0 &&
        currentMaxLength < requiredMaxLength &&
        currentMaxLength >= visibleLimit
      ) {
        control.maxLength = requiredMaxLength;
        control.setAttribute('maxlength', String(requiredMaxLength));
      }
    }
  
    function updateCharacterCounter(control, config) {
      var wrapper = getWrapperFromControl(control);
      var label = wrapper ? wrapper.querySelector(CHAR_LABEL_SELECTOR) : null;
      var remaining;
  
      if (!control || control.tagName !== 'TEXTAREA') {
        return;
      }
  
      if (!label) {
        return;
      }
  
      remaining = getRemainingCharacterCount(control.value, config);
      label.textContent = remaining + ' character' + (remaining === 1 ? '' : 's') + ' remaining';
    }
  
    function normalizeLookupKey(value) {
      return String(value || '')
        .replace(/&amp;/gi, '&')
        .replace(/&/g, ' and ')
        .replace(/\([^)]*(?:default|included|free|\+|£|\$|€)[^)]*\)/gi, ' ')
        .replace(/\[[^\]]*(?:default|included|free|\+|£|\$|€)[^\]]*\]/gi, ' ')
        .replace(/\b(?:default|included|free|no extra charge)\b/gi, ' ')
        .replace(/[+£$€]\s*\d+(?:[.,]\d+)?/g, ' ')
        .replace(/[-–—_/]+/g, ' ')
        .replace(/[.,!?;:()[\]{}"'*]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    }
  
    function isLookupMatch(a, b) {
      var left = normalizeLookupKey(a);
      var right = normalizeLookupKey(b);
  
      if (!left || !right) {
        return false;
      }
  
      if (left === right) {
        return true;
      }
  
      return (left.length > 3 && right.indexOf(left) !== -1) ||
        (right.length > 3 && left.indexOf(right) !== -1);
    }
  
    function hasOwn(object, key) {
      return Object.prototype.hasOwnProperty.call(object, key);
    }
  
    function normalizePath(path) {
      return String(path || '').replace(/\/$/, '') || '/';
    }
  
    function pathFromUrl(url) {
      var link = document.createElement('a');
      link.href = url || window.location.href;
      return normalizePath(link.pathname);
    }
  
    function getSessionStorage() {
      try {
        return window.sessionStorage || null;
      } catch (error) {
        return null;
      }
    }
  
    function limitValue(value, config) {
      var lines = limitEditingValue(value, config).split('\n');
      var outputLines = [];
      var line;
      var i;
  
      // Apply the actual engraving line breaks used by the preview and cart properties.
      for (i = 0; i < lines.length && outputLines.length < config.maxLines; i += 1) {
        line = lines[i];
  
        if (!line) {
          outputLines.push('');
          continue;
        }
  
        while (line.length && outputLines.length < config.maxLines) {
          outputLines.push(line.slice(0, config.maxCharsPerLine));
          line = line.slice(config.maxCharsPerLine);
        }
      }
  
      return outputLines.join('\n');
    }
  
    function getSelection(control) {
      try {
        if (typeof control.selectionStart === 'number' && typeof control.selectionEnd === 'number') {
          return {
            start: control.selectionStart,
            end: control.selectionEnd
          };
        }
      } catch (error) {
        return null;
      }
  
      return null;
    }
  
    function setSelection(control, selection) {
      if (!selection || typeof control.setSelectionRange !== 'function' || document.activeElement !== control) {
        return;
      }
  
      try {
        control.setSelectionRange(selection.start, selection.end);
      } catch (error) {
        // Some input types do not support selection ranges.
      }
    }
  
    function applyControlLimits(control, config) {
      var originalValue = control.value;
      var limitedValue = limitEditingValue(originalValue, config);
      var selection;
      var nextSelection;
  
      if (limitedValue === originalValue) {
        return false;
      }
  
      selection = getSelection(control);
      if (selection) {
        nextSelection = {
          start: limitEditingValue(originalValue.slice(0, selection.start), config).length,
          end: limitEditingValue(originalValue.slice(0, selection.end), config).length
        };
      }
  
      control.value = limitedValue;
      setSelection(control, nextSelection);
      dispatchControlEvents(control);
      return true;
    }
  
    function getBeforeInputText(event) {
      if (event.inputType === 'insertLineBreak' || event.inputType === 'insertParagraph') {
        return '\n';
      }
  
      if (event.data) {
        return event.data;
      }
  
      if (event.dataTransfer && typeof event.dataTransfer.getData === 'function') {
        return event.dataTransfer.getData('text/plain');
      }
  
      return '';
    }
  
    function getAllowedInsertedText(control, config, insertedText, selection) {
      var prefix = control.value.slice(0, selection.start);
      var suffix = control.value.slice(selection.end);
      var allowedText = '';
      var nextText;
      var candidate;
      var i;
  
      for (i = 0; i < insertedText.length; i += 1) {
        nextText = allowedText + insertedText.charAt(i);
        candidate = prefix + nextText + suffix;
  
        if (limitEditingValue(candidate, config) !== candidate) {
          break;
        }
  
        allowedText = nextText;
      }
  
      return allowedText;
    }
  
    function renderTextareaState(control, config) {
      var preview = control._mfEngravingPreview;
  
      growTextareaAfterInput(control);
  
      if (preview) {
        renderPreview(control, preview, config);
      }
    }
  
    function handleTextareaBeforeInput(control, event) {
      var wrapper;
      var config;
      var insertedText;
      var selection;
      var nextValue;
      var allowedText;
      var nextSelectionPosition;
  
      if (
        event.defaultPrevented ||
        event.isComposing ||
        (event.inputType && event.inputType.indexOf('delete') === 0)
      ) {
        return;
      }
  
      markTextareaInteraction(control);
      insertedText = getBeforeInputText(event);
      if (!insertedText) {
        return;
      }
  
      selection = getSelection(control);
      if (!selection) {
        return;
      }
  
      wrapper = getWrapperFromControl(control);
      config = parseConfig(wrapper);
      nextValue = control.value.slice(0, selection.start) +
        insertedText +
        control.value.slice(selection.end);
  
      if (limitEditingValue(nextValue, config) === nextValue) {
        return;
      }
  
      event.preventDefault();
      allowedText = getAllowedInsertedText(control, config, insertedText, selection);
  
      if (allowedText || selection.start !== selection.end) {
        control.value = control.value.slice(0, selection.start) +
          allowedText +
          control.value.slice(selection.end);
        nextSelectionPosition = selection.start + allowedText.length;
        setSelection(control, {
          start: nextSelectionPosition,
          end: nextSelectionPosition
        });
        control.dispatchEvent(makeEvent('input'));
      } else {
        renderTextareaState(control, config);
      }
    }
  
    function getAvailableSize(container) {
      var styles = window.getComputedStyle ? window.getComputedStyle(container) : null;
      var horizontalPadding = 0;
      var verticalPadding = 0;
  
      if (styles) {
        horizontalPadding = toPixels(styles.paddingLeft) + toPixels(styles.paddingRight);
        verticalPadding = toPixels(styles.paddingTop) + toPixels(styles.paddingBottom);
      }
  
      return {
        width: Math.max(container.clientWidth - horizontalPadding, 0),
        height: Math.max(container.clientHeight - verticalPadding, 0)
      };
    }
  
    function getPreviewAspectRatio(config) {
      return config && config.lengthMm && config.heightMm
        ? config.lengthMm / config.heightMm
        : 0;
    }
  
    function getPreviewPaddingForAspect(aspectRatio) {
      if (isMobileWidth()) {
        if (aspectRatio >= 8) {
          return '2px 11px';
        }
  
        if (aspectRatio >= 5) {
          return '3px 11px';
        }
  
        return '6px 11px';
      }
  
      if (aspectRatio >= 8) {
        return '3px 14px';
      }
  
      if (aspectRatio >= 5) {
        return '4px 14px';
      }
  
      return '7px 14px';
    }
  
    function getRenderedWidth(element) {
      var rect = element && typeof element.getBoundingClientRect === 'function'
        ? element.getBoundingClientRect()
        : null;
  
      return rect && rect.width
        ? rect.width
        : (element ? element.offsetWidth || element.clientWidth || 0 : 0);
    }
  
    function getPreviewFallbackWidth() {
      return isMobileWidth()
        ? MOBILE_PREVIEW_FALLBACK_DIMENSION_WIDTH
        : PREVIEW_FALLBACK_DIMENSION_WIDTH;
    }
  
    function getPreviewHeightForAspect(preview, aspectRatio) {
      var width = getRenderedWidth(preview) || getPreviewFallbackWidth();
  
      return Math.max(
        Math.round(width / aspectRatio),
        PREVIEW_MIN_DIMENSION_HEIGHT
      );
    }
  
    function applyPreviewGeometry(preview, config) {
      var aspectRatio = getPreviewAspectRatio(config);
      var height;
  
      if (!preview) {
        return;
      }
  
      if (!aspectRatio) {
        preview.style.aspectRatio = '';
        preview.style.height = '';
        preview.style.maxHeight = '';
        preview.style.padding = '';
        preview.style.width = '';
        return;
      }
  
      preview.style.width = aspectRatio >= 8 && !isMobileWidth()
        ? PREVIEW_LONG_RATIO_WIDTH
        : '';
      preview.style.aspectRatio = '';
      preview.style.padding = getPreviewPaddingForAspect(aspectRatio);
      preview.style.maxHeight = 'none';
  
      height = getPreviewHeightForAspect(preview, aspectRatio);
      preview.style.height = height + 'px';
    }
  
    function fitPreviewText(previewTextNode, previewContainer, config) {
      var available;
      var size;
      var minSize;
      var shouldFitWidth = !isMobileWidth();
  
      applyPreviewGeometry(previewContainer, config);
  
      available = getAvailableSize(previewContainer);
      size = getPreviewMaxFontSize(config);
      minSize = getPreviewMinFontSize();
  
      if (!available.width || !available.height) {
        return;
      }
  
      previewTextNode.style.fontSize = size + 'px';
  
      while (size > minSize) {
        if (
          (!shouldFitWidth || previewTextNode.scrollWidth <= available.width) &&
          previewTextNode.scrollHeight <= available.height
        ) {
          break;
        }
  
        size -= 1;
        previewTextNode.style.fontSize = size + 'px';
      }
    }
  
    function scheduleFontReadyPreviewFit(previewTextNode, previewContainer) {
      var fonts = document.fonts;
  
      if (
        !fonts ||
        !fonts.ready ||
        typeof fonts.ready.then !== 'function' ||
        previewTextNode._mfEngravingFontReadyFitQueued
      ) {
        return;
      }
  
      previewTextNode._mfEngravingFontReadyFitQueued = true;
  
      fonts.ready.then(function () {
        previewTextNode._mfEngravingFontReadyFitQueued = false;
  
        if (!previewTextNode.parentNode || !previewContainer.parentNode) {
          return;
        }
  
        requestFrame(function () {
          fitPreviewText(previewTextNode, previewContainer, parseConfig(getWrapperFromPreview(previewContainer)));
        });
      });
    }
  
    function renderPreview(control, preview, config) {
      var previewTextNode = preview.querySelector('.' + PREVIEW_TEXT_CLASS);
      var formattedValue = limitValue(control.value, config);
      var isEmpty = !formattedValue.trim();
  
      if (!previewTextNode) {
        return;
      }
  
      applyPreviewGeometry(preview, config);
      preview.setAttribute('data-empty', isEmpty ? 'true' : 'false');
      previewTextNode.textContent = isEmpty ? 'Enter text above to preview here' : formattedValue;
      applySelectedPreviewFont(control, previewTextNode);
      updatePreviewLabel(control, preview, config);
      updateCharacterCounter(control, config);
  
      requestFrame(function () {
        updateCharacterCounter(control, config);
        fitPreviewText(previewTextNode, preview, config);
        scheduleFontReadyPreviewFit(previewTextNode, preview);
      });
    }
  
    function getWrapperFromControl(control) {
      return closestElement(control, FIELD_SELECTOR);
    }
  
    function getFieldControls(root) {
      var scope = root || document;
      return Array.prototype.slice.call(scope.querySelectorAll(FIELD_TEXT_CONTROL_SELECTOR))
        .filter(function (control) {
          return !isTextareaEnhancementDisabled(control);
        });
    }
  
    function getFontPreviewClass(styleNumber) {
      if (styleNumber < 1 || styleNumber > FONT_PREVIEW_STYLE_COUNT) {
        return '';
      }
  
      return FONT_PREVIEW_CLASS_PREFIX + styleNumber;
    }
  
    function getFontPreviewStyle(styleNumber) {
      return FONT_PREVIEW_STYLES[styleNumber - 1] || null;
    }
  
    function getFontPreviewStyleName(styleNumber) {
      var style = getFontPreviewStyle(styleNumber);
  
      return style ? style.name : '';
    }
  
    function clearPreviewFontClasses(previewTextNode) {
      var i;
  
      for (i = 1; i <= FONT_PREVIEW_STYLE_COUNT; i += 1) {
        previewTextNode.classList.remove(getFontPreviewClass(i));
      }
    }
  
    function getOptionLabels(wrapper) {
      return wrapper ? Array.prototype.slice.call(wrapper.getElementsByTagName('label')) : [];
    }
  
    function isFontOptionWrapper(wrapper) {
      var labels = getOptionLabels(wrapper);
      var candidates = [
        wrapper && typeof wrapper.getAttribute === 'function' ? wrapper.getAttribute('data-option-id') : '',
        wrapper && wrapper.id
      ];
      var i;
      var key;
  
      for (i = 0; i < labels.length; i += 1) {
        candidates.push(labels[i].textContent);
      }
  
      for (i = 0; i < candidates.length; i += 1) {
        key = normalizeLookupKey(candidates[i]);
  
        if (key === FONT_OPTION_LABEL || key.indexOf(FONT_OPTION_LABEL + ' ') === 0) {
          return true;
        }
      }
  
      return false;
    }
  
    function findFontWrapper(scope) {
      var wrappers = (scope || document).querySelectorAll(APO_OPTION_SELECTOR);
      var found = null;
  
      Array.prototype.some.call(wrappers, function (wrapper) {
        if (isFontOptionWrapper(wrapper)) {
          found = wrapper;
          return true;
        }
  
        return false;
      });
  
      return found;
    }
  
    function findFontControl(scope) {
      var wrapper = elementMatches(scope, APO_OPTION_SELECTOR) && isFontOptionWrapper(scope)
        ? scope
        : findFontWrapper(scope);
  
      if (!wrapper) {
        return null;
      }
  
      return wrapper.querySelector('select' + CONTROL_SELECTOR) ||
        wrapper.querySelector('select') ||
        wrapper.querySelector('input' + CONTROL_SELECTOR + ':checked') ||
        wrapper.querySelector('input:checked');
    }
  
    function getFontStyleNumberFromText(value) {
      var match = normalizeLookupKey(value).match(/\b(?:font\s*)?style\s*(\d+)\b|\bfont\s*(\d+)\b/);
      var number = match ? parseInt(match[1] || match[2], 10) : 0;
  
      return number >= 1 && number <= FONT_PREVIEW_STYLE_COUNT ? number : 0;
    }
  
    function getFontStyleNumberFromName(value) {
      var key = normalizeLookupKey(value);
      var styleKey;
      var i;
  
      for (i = 0; i < FONT_PREVIEW_STYLES.length; i += 1) {
        styleKey = normalizeLookupKey(FONT_PREVIEW_STYLES[i].name);
  
        if (
          key &&
          (
            key === styleKey ||
            (' ' + key + ' ').indexOf(' ' + styleKey + ' ') !== -1
          )
        ) {
          return i + 1;
        }
      }
  
      return 0;
    }
  
    function getFontStyleNumberFromClassName(className) {
      var match = String(className || '').match(/\b(?:font-style|font|mf-font)-(\d+)\b/);
      var number = match ? parseInt(match[1], 10) : 0;
  
      return number >= 1 && number <= FONT_PREVIEW_STYLE_COUNT
        ? number
        : getFontStyleNumberFromName(className);
    }
  
    function getAttributeValue(element, attributeName) {
      return element && typeof element.getAttribute === 'function'
        ? element.getAttribute(attributeName)
        : '';
    }
  
    function getFontStyleNumberFromAttributes(element) {
      var candidates = [
        getAttributeValue(element, 'data-font'),
        getAttributeValue(element, 'data-font-name'),
        getAttributeValue(element, 'data-font-style'),
        getAttributeValue(element, 'data-preview-font'),
        getAttributeValue(element, 'data-mf-font')
      ];
      var number;
      var i;
  
      for (i = 0; i < candidates.length; i += 1) {
        number = getFontStyleNumberFromName(candidates[i]) ||
          getFontStyleNumberFromText(candidates[i]);
  
        if (number) {
          return number;
        }
      }
  
      return 0;
    }
  
    function getFontStyleNumberFromSelectOption(option) {
      var text = option ? option.textContent : '';
      var value = option ? option.value : '';
  
      return getFontStyleNumberFromAttributes(option) ||
        getFontStyleNumberFromClassName(option ? option.className : '') ||
        getFontStyleNumberFromName(text) ||
        getFontStyleNumberFromName(value) ||
        getFontStyleNumberFromText(text) ||
        getFontStyleNumberFromText(value);
    }
  
    function getFontStyleNumberFromInputControl(control) {
      var label = getInputChoiceText(closestElement(control, APO_OPTION_SELECTOR), control);
  
      return getFontStyleNumberFromAttributes(control) ||
        getFontStyleNumberFromClassName(control ? control.className : '') ||
        getFontStyleNumberFromName(label) ||
        getFontStyleNumberFromName(control ? control.value : '') ||
        getFontStyleNumberFromText(label) ||
        getFontStyleNumberFromText(control ? control.value : '');
    }
  
    function isPlaceholderFontOption(option) {
      var key = normalizeLookupKey((option && option.value) || (option && option.textContent));
  
      return !key ||
        key === 'font' ||
        key.indexOf('choose') !== -1 ||
        key.indexOf('select') !== -1;
    }
  
    function getFontStyleNumberFromOptionOrder(selectControl) {
      var options = selectControl.options || [];
      var count = 0;
      var option;
      var i;
  
      for (i = 0; i < options.length; i += 1) {
        option = options[i];
  
        if (isPlaceholderFontOption(option)) {
          continue;
        }
  
        count += 1;
  
        if (i === selectControl.selectedIndex) {
          return count <= FONT_PREVIEW_STYLE_COUNT ? count : 0;
        }
      }
  
      return 0;
    }
  
    function getSelectedFontStyleNumber(fontControl) {
      var option;
      var number;
  
      if (!fontControl) {
        return 0;
      }
  
      if (fontControl.tagName === 'SELECT') {
        option = fontControl.options[fontControl.selectedIndex];
        number = getFontStyleNumberFromSelectOption(option) ||
          getFontStyleNumberFromOptionOrder(fontControl);
        return number;
      }
  
      return getFontStyleNumberFromInputControl(fontControl);
    }
  
    function cleanDisplayText(value) {
      return String(value || '').replace(/\s+/g, ' ').trim();
    }
  
    function getSelectedFontDisplayName(fontControl) {
      var option;
      var label;
      var styleNumber;
      var text;
  
      if (!fontControl) {
        return '';
      }
  
      styleNumber = getSelectedFontStyleNumber(fontControl);
  
      if (fontControl.tagName === 'SELECT') {
        option = fontControl.options[fontControl.selectedIndex];
  
        if (!option || isPlaceholderFontOption(option)) {
          return '';
        }
  
        text = cleanDisplayText(option.textContent || option.value);
  
        if (styleNumber && getFontStyleNumberFromText(text)) {
          return getFontPreviewStyleName(styleNumber);
        }
  
        return text || getFontPreviewStyleName(styleNumber);
      }
  
      label = getInputChoiceText(closestElement(fontControl, APO_OPTION_SELECTOR), fontControl);
      text = cleanDisplayText(label || fontControl.value);
  
      if (styleNumber && getFontStyleNumberFromText(text)) {
        return getFontPreviewStyleName(styleNumber);
      }
  
      return text || getFontPreviewStyleName(styleNumber);
    }
  
    function getPreviewLabelText(control, config) {
      var scope = closestElement(control, 'form') || document;
      var fontName = getSelectedFontDisplayName(findFontControl(scope));
      var totalChars = getVisibleCharacterLimit(config);
      var linesText = config.maxLines + ' line' + (config.maxLines === 1 ? '' : 's');
      var perLineText = config.maxCharsPerLine + ' per line';
      var specText = config.maxLines === 1
        ? 'Up to ' + totalChars + ' character' + (totalChars === 1 ? '' : 's') + ' on 1 line.'
        : 'Up to ' + totalChars + ' characters across ' + linesText + ', ' + perLineText + '.';
  
      return 'A preview of your engraving' + (fontName ? ' in ' + fontName : '') + '. ' +
        specText + ' ' +
        'If you\'d like a proof before we begin, let us know in Notes for the Maker.';
    }
  
    function getPreviewLabel(preview) {
      var label = preview ? preview.previousElementSibling : null;
  
      return label && label.classList.contains(PREVIEW_LABEL_CLASS) ? label : null;
    }
  
    function updatePreviewLabel(control, preview, config) {
      var label = getPreviewLabel(preview);
  
      if (!label) {
        return;
      }
  
      label.textContent = getPreviewLabelText(control, config);
    }
  
    function applySelectedPreviewFont(control, previewTextNode) {
      var scope = closestElement(control, 'form') || document;
      var styleNumber = getSelectedFontStyleNumber(findFontControl(scope));
      var previewClass;
  
      clearPreviewFontClasses(previewTextNode);
  
      if (!styleNumber) {
        return;
      }
  
      previewClass = getFontPreviewClass(styleNumber);
      if (previewClass) {
        previewTextNode.classList.add(previewClass);
      }
    }
  
    function renderPreviewsForFontControl(fontControl) {
      var scope = closestElement(fontControl, 'form') || document;
  
      getFieldControls(scope).forEach(function (control) {
        var wrapper = getWrapperFromControl(control);
        var preview = control._mfEngravingPreview || (wrapper ? getExistingPreview(wrapper) : null);
        var config = parseConfig(wrapper);
  
        if (preview) {
          control._mfEngravingWrapper = wrapper;
          control._mfEngravingPreview = preview;
          renderPreview(control, preview, config);
        }
      });
    }
  
    function bindFontControl(fontControl) {
      if (!fontControl || fontControl._mfEngravingFontBound) {
        return;
      }
  
      fontControl._mfEngravingFontBound = true;
  
      fontControl.addEventListener('change', function () {
        renderPreviewsForFontControl(fontControl);
      });
    }
  
    function initializeFontControls(root) {
      var scope = root || document;
      var wrappers = scope.querySelectorAll(APO_OPTION_SELECTOR);
  
      Array.prototype.forEach.call(wrappers, function (wrapper) {
        if (isFontOptionWrapper(wrapper)) {
          bindFontControl(findFontControl(wrapper));
        }
      });
    }
  
    function getFieldLabel(wrapper, control) {
      var labels = wrapper ? wrapper.getElementsByTagName('label') : [];
      var fallback = wrapper && wrapper.getAttribute('data-option-id')
        ? wrapper.getAttribute('data-option-id')
        : control.name || 'Engraving';
      var label = null;
      var i;
  
      if (control.id) {
        for (i = 0; i < labels.length; i += 1) {
          if (labels[i].htmlFor === control.id) {
            label = labels[i];
            break;
          }
        }
      }
  
      if (!label && labels.length) {
        label = labels[0];
      }
  
      return String(label ? label.textContent : fallback)
        .replace(/\s+/g, ' ')
        .replace(/[\[\]]/g, '')
        .replace(/:$/, '')
        .trim()
        .slice(0, 80) || 'Engraving';
    }
  
    function getHiddenPropertyName(control) {
      var wrapper = getWrapperFromControl(control);
      return 'properties[' + HIDDEN_PROPERTY_PREFIX + getFieldLabel(wrapper, control) + ']';
    }
  
    function getMarkerValue(control, config) {
      return limitValue(control.value, config).replace(/\n/g, NEWLINE_MARKER);
    }
  
    function ensureHiddenMarkerInput(control, markerValue) {
      var form = closestElement(control, 'form');
      var input = control._mfEngravingMarkerInput;

      if (!form) {
        return;
      }

      if (!markerValue.trim()) {
        if (input && input.parentNode) {
          input.parentNode.removeChild(input);
        }

        control._mfEngravingMarkerInput = null;
        return;
      }

      if (!input || !input.parentNode) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.setAttribute('data-mf-engraving-marker', 'true');
        form.appendChild(input);
        control._mfEngravingMarkerInput = input;
      }

      input.name = getHiddenPropertyName(control);
      input.value = markerValue;
    }
  
    function getCartEditPayload() {
      var storage;
      var rawPayload;
      var payload;
  
      if (state.editPayload !== undefined) {
        return state.editPayload;
      }
  
      state.editPayload = null;
      storage = getSessionStorage();
  
      if (!storage) {
        return null;
      }
  
      rawPayload = storage.getItem(CART_EDIT_STORAGE_KEY);
      if (!rawPayload) {
        return null;
      }
  
      try {
        payload = JSON.parse(rawPayload);
      } catch (error) {
        storage.removeItem(CART_EDIT_STORAGE_KEY);
        return null;
      }
  
      if (
        !payload ||
        !payload.properties ||
        (payload.timestamp && Date.now() - payload.timestamp > CART_EDIT_MAX_AGE_MS) ||
        pathFromUrl(payload.url) !== normalizePath(window.location.pathname)
      ) {
        storage.removeItem(CART_EDIT_STORAGE_KEY);
        return null;
      }
  
      state.editPayload = payload;
      return state.editPayload;
    }
  
    function updateSubmitButtonForCartEdit() {
      var payload = getCartEditPayload();
      var button;
  
      if (!payload) {
        return;
      }
  
      button = document.getElementById('AddToCart') ||
        document.querySelector(PRODUCT_FORM_SELECTOR + ' button[type="submit"], ' + PRODUCT_FORM_SELECTOR + ' button:not([type])');
  
      if (button && button.dataset.mfCartEditLabelApplied !== 'true') {
        button.dataset.mfCartEditLabelApplied = 'true';
        button.textContent = 'Update basket';
        button.setAttribute('aria-label', 'Update basket');
      }
    }
  
    function clearStoredCartEditPayload() {
      var storage = getSessionStorage();
  
      if (storage && !state.editPayloadCleared) {
        storage.removeItem(CART_EDIT_STORAGE_KEY);
        state.editPayloadCleared = true;
      }
    }
  
    function scheduleCartEditPayloadClear() {
      if (state.editPayloadClearTimer || state.editPayloadCleared) {
        return;
      }
  
      state.editPayloadClearTimer = window.setTimeout(clearStoredCartEditPayload, CART_EDIT_CLEAR_DELAY_MS);
    }
  
    function markCartLineForReplacement(form) {
      var payload = getCartEditPayload();
      var storage = getSessionStorage();
      var quantityInput;
      var addedQuantity = 1;
  
      if (!payload || !payload.key || !storage) {
        return;
      }
  
      quantityInput = form ? form.querySelector('[name="quantity"]') : null;
      if (quantityInput && quantityInput.value) {
        addedQuantity = Math.max(parseInt(quantityInput.value, 10) || 1, 1);
      }
  
      storage.setItem(CART_EDIT_REPLACEMENT_STORAGE_KEY, JSON.stringify({
        key: payload.key,
        line: payload.line,
        variantId: payload.variantId,
        properties: payload.properties,
        cartKeys: Array.isArray(payload.cartKeys) ? payload.cartKeys : null,
        originalQuantity: payload.quantity || 1,
        addedQuantity: addedQuantity,
        timestamp: Date.now()
      }));
    }
  
    function buildCartEditLookup(properties) {
      var lookup = {};
      var entries = [];
      var uploads = [];
      var entry;
      var i;
      var publicKey;
      var value;
      var key;
  
      if (Array.isArray(properties)) {
        for (i = 0; i < properties.length; i += 1) {
          entry = properties[i];
  
          if (Array.isArray(entry)) {
            entries.push({
              key: entry[0],
              value: entry[1]
            });
          } else if (entry && typeof entry === 'object') {
            entries.push({
              key: entry.name || entry.first || entry.key,
              value: entry.value || entry.last
            });
          }
        }
      } else {
        for (key in properties) {
          if (hasOwn(properties, key)) {
            entries.push({
              key: key,
              value: properties[key]
            });
          }
        }
      }
  
      for (i = 0; i < entries.length; i += 1) {
        key = entries[i].key;
        value = entries[i].value;
  
        if (!key || value === null || value === undefined || value === '') {
          continue;
        }
  
        if (CART_EDIT_UPLOAD_PROPERTY.test(String(key)) && /^https:\/\//.test(String(value))) {
          uploads.push({
            n: parseInt(String(key).replace(CART_EDIT_UPLOAD_PROPERTY, '$1'), 10) || 1,
            url: String(value)
          });
        }

        publicKey = key;
        value = toEditingValue(value);
  
        if (key.indexOf(HIDDEN_PROPERTY_PREFIX) === 0) {
          publicKey = key.slice(HIDDEN_PROPERTY_PREFIX.length);
          lookup[normalizeLookupKey(publicKey)] = value;
          if (!lookup.__mfFirstLineBreakValue) {
            lookup.__mfFirstLineBreakValue = value;
          }
          continue;
        }
  
        publicKey = normalizeLookupKey(publicKey);
  
        if (publicKey && !hasOwn(lookup, publicKey)) {
          lookup[publicKey] = value;
        }
      }
  
      lookup.__mfUploads = uploads.sort(function (a, b) {
        return a.n - b.n;
      });

      return lookup;
    }
  
    function getCartEditLookup(payload) {
      if (!payload._mfLookup) {
        payload._mfLookup = buildCartEditLookup(payload.properties || {});
      }
  
      return payload._mfLookup;
    }
  
    function isApoHiddenControl(control) {
      return String(control.type || '').toLowerCase() === 'hidden' &&
        control.classList &&
        control.classList.contains(CONTROL_SELECTOR.slice(1));
    }
  
    function isChoiceControl(control) {
      var type = String(control.type || '').toLowerCase();
      return type === 'radio' || type === 'checkbox';
    }
  
    function isSelectControl(control) {
      return control && control.tagName === 'SELECT';
    }
  
    function isTextRestoreControl(control) {
      var type = String(control.type || '').toLowerCase();
  
      return control &&
        (control.tagName === 'TEXTAREA' ||
          (
            control.tagName === 'INPUT' &&
            type !== 'radio' &&
            type !== 'checkbox' &&
            type !== 'file' &&
            type !== 'submit' &&
            type !== 'button' &&
            type !== 'reset'
          ));
    }
  
    function getRestoreControls(wrapper) {
      var controls = wrapper.querySelectorAll('textarea, select, input');
  
      return Array.prototype.filter.call(controls, function (control) {
        var type = String(control.type || '').toLowerCase();
  
        return !isTextareaEnhancementDisabled(control) &&
          (type !== 'hidden' || isApoHiddenControl(control)) &&
          type !== 'submit' &&
          type !== 'button' &&
          type !== 'reset' &&
          !control.disabled;
      });
    }
  
    function getControlLabel(wrapper, control) {
      var labels = wrapper ? wrapper.getElementsByTagName('label') : [];
      var label = null;
      var i;
  
      if (control && control.id) {
        for (i = 0; i < labels.length; i += 1) {
          if (labels[i].htmlFor === control.id) {
            label = labels[i];
            break;
          }
        }
      }
  
      if (!label && labels.length) {
        label = labels[0];
      }
  
      return label ? label.textContent : '';
    }
  
    function findRestoreValue(wrapper, control, lookup) {
      var labels = wrapper ? wrapper.getElementsByTagName('label') : [];
      var wrapperText = normalizeLookupKey(wrapper ? wrapper.textContent : '');
      var candidates = [
        getFieldLabel(wrapper, control),
        getControlLabel(wrapper, control),
        wrapper.getAttribute('data-option-id'),
        wrapper.id
      ];
      var i;
      var key;
      var lookupKey;
  
      if (elementMatches(wrapper, FIELD_SELECTOR) && lookup.__mfFirstLineBreakValue) {
        return lookup.__mfFirstLineBreakValue;
      }
  
      for (i = 0; i < labels.length; i += 1) {
        key = normalizeLookupKey(labels[i].textContent);
  
        if (key && hasOwn(lookup, key)) {
          return lookup[key];
        }
      }
  
      if (wrapperText) {
        for (lookupKey in lookup) {
          if (
            hasOwn(lookup, lookupKey) &&
            lookupKey.indexOf('__mf') !== 0 &&
            lookupKey.length > 3 &&
            wrapperText.indexOf(lookupKey) !== -1
          ) {
            return lookup[lookupKey];
          }
        }
      }
  
      for (i = 0; i < candidates.length; i += 1) {
        key = normalizeLookupKey(candidates[i]);
  
        if (key && hasOwn(lookup, key)) {
          return lookup[key];
        }
      }
  
      for (i = 0; i < candidates.length; i += 1) {
        key = normalizeLookupKey(candidates[i]);
  
        if (!key) {
          continue;
        }
  
        for (lookupKey in lookup) {
          if (
            hasOwn(lookup, lookupKey) &&
            lookupKey.indexOf('__mf') !== 0 &&
            (key.indexOf(lookupKey) !== -1 || lookupKey.indexOf(key) !== -1)
          ) {
            return lookup[lookupKey];
          }
        }
      }
  
      return null;
    }
  
    function getInputChoiceText(wrapper, control) {
      var labels = wrapper ? wrapper.getElementsByTagName('label') : [];
      var label;
      var i;
  
      if (control.id) {
        for (i = 0; i < labels.length; i += 1) {
          if (labels[i].htmlFor === control.id) {
            label = labels[i];
            break;
          }
        }
      }
  
      if (!label && closestElement(control, 'label')) {
        label = closestElement(control, 'label');
      }
  
      return label ? label.textContent : control.value;
    }
  
    function splitChoiceValue(value) {
      return String(value || '')
        .split(/\s*,\s*|\n/)
        .map(normalizeLookupKey)
        .filter(Boolean);
    }
  
    function setTextControl(control, value) {
      if (control.value === value) {
        return true;
      }
  
      control.value = value;
      dispatchControlEvents(control);
      return true;
    }
  
    function setSelectControl(control, value) {
      var options = control.options || [];
      var i;
  
      for (i = 0; i < options.length; i += 1) {
        if (
          isLookupMatch(options[i].value, value) ||
          isLookupMatch(options[i].textContent, value)
        ) {
          if (control.value !== options[i].value) {
            control.value = options[i].value;
            dispatchControlEvents(control);
            return true;
          }
  
          return true;
        }
      }
  
      return false;
    }
  
    function setChoiceControls(wrapper, controls, value) {
      var wantedValues = splitChoiceValue(value);
      var changed = false;
      var matched = false;
  
      controls.forEach(function (control) {
        var type = String(control.type || '').toLowerCase();
        var choiceText = normalizeLookupKey(getInputChoiceText(wrapper, control));
        var choiceValue = normalizeLookupKey(control.value);
        var shouldCheck = wantedValues.some(function (wantedValue) {
          return isLookupMatch(choiceValue, wantedValue) || isLookupMatch(choiceText, wantedValue);
        });
  
        if (shouldCheck) {
          matched = true;
        }
  
        if ((type === 'radio' || type === 'checkbox') && control.checked !== shouldCheck) {
          control.checked = shouldCheck;
          dispatchControlEvents(control);
          changed = true;
        }
      });
  
      return matched || changed;
    }
  
    function syncApoHiddenControls(wrapper, value) {
      var controls = wrapper ? wrapper.querySelectorAll('input' + CONTROL_SELECTOR + '[type="hidden"]') : [];
  
      Array.prototype.forEach.call(controls, function (control) {
        if (control.value !== value) {
          control.value = value;
          dispatchControlEvents(control);
        }
      });
    }
  
    function applyCartEditUploadNote(wrapper, uploads) {
      // The browser never lets a script put a file into an upload box, so the files already uploaded are listed
      // under it instead; the cart page carries them to the updated line (templates/cart.liquid)
      var note;
      var link;
      var i;

      if (!uploads || !uploads.length) {
        return false;
      }

      if (wrapper.querySelector('.' + CART_EDIT_UPLOAD_NOTE_CLASS)) {
        return true;
      }

      note = document.createElement('p');
      note.className = CART_EDIT_UPLOAD_NOTE_CLASS;
      note.appendChild(document.createTextNode(
        'Your ' + (uploads.length === 1 ? 'uploaded file stays' : uploads.length + ' uploaded files stay') + ' with this item ('
      ));

      for (i = 0; i < uploads.length; i += 1) {
        link = document.createElement('a');
        link.href = uploads[i].url;
        link.target = '_blank';
        link.rel = 'noopener';
        link.textContent = 'file ' + uploads[i].n;

        if (i > 0) {
          note.appendChild(document.createTextNode(', '));
        }

        note.appendChild(link);
      }

      note.appendChild(document.createTextNode(
        '). Upload again only if you want to replace ' + (uploads.length === 1 ? 'it.' : 'them.')
      ));
      wrapper.appendChild(note);

      return true;
    }

    function applyCartEditRestoreToWrapper(wrapper, lookup) {
      var controls;
      var choiceControls;
      var selectControl = null;
      var textControl = null;
      var value;
      var lookupControl;
      var i;
  
      if (wrapper._mfCartEditUserTouched) {
        return false;
      }
  
      if (wrapper.querySelector('input[type="file"]')) {
        return applyCartEditUploadNote(wrapper, lookup.__mfUploads);
      }

      controls = getRestoreControls(wrapper);
      if (!controls.length) {
        return false;
      }
  
      choiceControls = controls.filter(isChoiceControl);
  
      for (i = 0; i < controls.length; i += 1) {
        if (!selectControl && isSelectControl(controls[i])) {
          selectControl = controls[i];
        }
  
        if (!textControl && isTextRestoreControl(controls[i])) {
          textControl = controls[i];
        }
      }
  
      lookupControl = textControl || selectControl || choiceControls[0] || controls[0];
      value = findRestoreValue(wrapper, lookupControl, lookup);
  
      if (value === null) {
        return false;
      }
  
      if (choiceControls.length) {
        if (setChoiceControls(wrapper, choiceControls, value)) {
          syncApoHiddenControls(wrapper, value);
          return true;
        }
  
        return false;
      }
  
      if (selectControl) {
        if (setSelectControl(selectControl, value)) {
          return true;
        }
  
        return false;
      }
  
      if (textControl && setTextControl(textControl, value)) {
        return true;
      }
  
      return false;
    }
  
    function restoreCartEditFields() {
      var payload = getCartEditPayload();
      var lookup;
      var wrappers;
      var appliedCount = 0;
  
      if (!payload) {
        return;
      }
  
      lookup = getCartEditLookup(payload);
      wrappers = document.querySelectorAll(APO_OPTION_SELECTOR);
  
      Array.prototype.forEach.call(wrappers, function (wrapper) {
        if (applyCartEditRestoreToWrapper(wrapper, lookup)) {
          appliedCount += 1;
        }
      });
  
      if (appliedCount > 0) {
        scheduleCartEditPayloadClear();
      }
    }
  
    function ensureCartEditReapplyLoop() {
      var payload = getCartEditPayload();
  
      if (!payload || state.editPayloadCleared || state.editPayloadReapplyTimer) {
        return;
      }
  
      state.editPayloadReapplyUntil = Date.now() + CART_EDIT_REAPPLY_DURATION_MS;
      state.editPayloadReapplyTimer = window.setInterval(function () {
        if (state.editPayloadCleared || Date.now() > state.editPayloadReapplyUntil) {
          window.clearInterval(state.editPayloadReapplyTimer);
          state.editPayloadReapplyTimer = null;
          return;
        }
  
        restoreCartEditFields();
      }, CART_EDIT_REAPPLY_INTERVAL_MS);
    }
  
    function installCartEditUserTouchGuard() {
      if (state.editUserTouchGuardInstalled) {
        return;
      }
  
      document.addEventListener('input', function (event) {
        var wrapper;
  
        if (!event.isTrusted) {
          return;
        }
  
        wrapper = closestElement(event.target, APO_OPTION_SELECTOR);
        if (wrapper) {
          wrapper._mfCartEditUserTouched = true;
        }
      }, true);
  
      document.addEventListener('change', function (event) {
        var wrapper;
  
        if (!event.isTrusted) {
          return;
        }
  
        wrapper = closestElement(event.target, APO_OPTION_SELECTOR);
        if (wrapper) {
          wrapper._mfCartEditUserTouched = true;
        }
      }, true);
  
      state.editUserTouchGuardInstalled = true;
    }
  
    function prepareControlForSubmit(control) {
      var wrapper = getWrapperFromControl(control);
      var config = parseConfig(wrapper);
      var formattedValue = limitValue(control.value, config);
      var markerValue = formattedValue.replace(/\n/g, NEWLINE_MARKER);
      var preview = control._mfEngravingPreview;
  
      if (control._mfEngravingPreSubmitValue === undefined) {
        control._mfEngravingPreSubmitValue = limitEditingValue(control.value, config);
      }
  
      control.dataset.mfEngravingSubmitting = 'true';
      ensureHiddenMarkerInput(control, markerValue);
  
      if (control.value !== formattedValue) {
        control.value = formattedValue;
        dispatchControlEvents(control);
      }
  
      if (preview) {
        renderPreview(control, preview, config);
      }
    }
  
    function restoreControlForEditing(control) {
      var wrapper = getWrapperFromControl(control);
      var config = parseConfig(wrapper);
      var editingValue = control._mfEngravingPreSubmitValue === undefined
        ? limitEditingValue(control.value, config)
        : limitEditingValue(control._mfEngravingPreSubmitValue, config);
      var preview = control._mfEngravingPreview;
  
      delete control.dataset.mfEngravingSubmitting;
      delete control._mfEngravingPreSubmitValue;
  
      if (control.value !== editingValue) {
        control.value = editingValue;
        dispatchControlEvents(control);
      }
  
      if (preview) {
        renderPreview(control, preview, config);
      }
    }
  
    function scheduleRestore(form) {
      window.clearTimeout(form._mfEngravingRestoreTimer);
      form._mfEngravingRestoreTimer = window.setTimeout(function () {
        getFieldControls(form).forEach(restoreControlForEditing);
      }, SUBMIT_RESTORE_MS);
    }
  
    function getShopifyPropertyName(wrapper, control) {
      var label = getFieldLabel(wrapper, control);
      var starIdx = label.lastIndexOf(' * ');
      return starIdx !== -1 ? label.substring(0, starIdx) : label;
    }

    function saveLineBreakAttributes(form) {
      var controls, variantInput, variantId, timestamp, attributes, hasData;
      var storage, trackerJson, tracker, variantStack, oldKeys, isEdit;
      var newKeys;

      if (form._mfLbSent) {
        return;
      }
      form._mfLbSent = true;

      controls = getFieldControls(form);
      variantInput = form.querySelector('[name="id"]');
      variantId = variantInput ? variantInput.value : '0';
      timestamp = String(Date.now());
      attributes = {};
      hasData = false;
      newKeys = [];

      storage = getSessionStorage();
      trackerJson = storage ? storage.getItem('mf_lb_tracker') : null;
      tracker = trackerJson ? JSON.parse(trackerJson) : {};
      variantStack = tracker[variantId] || [];
      isEdit = !!getCartEditPayload();

      if (isEdit && variantStack.length > 0) {
        oldKeys = variantStack.pop();
        oldKeys.forEach(function (key) { attributes[key] = ''; });
      }

      controls.forEach(function (control) {
        var wrapper = getWrapperFromControl(control);
        var config = parseConfig(wrapper);
        var markerValue = getMarkerValue(control, config);
        var propertyName = getShopifyPropertyName(wrapper, control);

        if (!propertyName || propertyName === 'Engraving') {
          return;
        }

        if (markerValue.trim() && markerValue.indexOf(NEWLINE_MARKER) !== -1) {
          var key = CART_ATTR_PREFIX + variantId + ':' + timestamp + ':' + propertyName;
          attributes[key] = markerValue;
          newKeys.push(key);
          hasData = true;
        }
      });

      if (hasData) {
        variantStack.push(newKeys);
        tracker[variantId] = variantStack;
        if (storage) {
          storage.setItem('mf_lb_tracker', JSON.stringify(tracker));
        }

        if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
          navigator.sendBeacon(
            '/cart/update.js',
            new Blob(
              [JSON.stringify({ attributes: attributes })],
              { type: 'application/json' }
            )
          );
        }
      }
    }

    function prepareFormForSubmit(form) {
      markCartLineForReplacement(form);
      getFieldControls(form).forEach(prepareControlForSubmit);
      scheduleRestore(form);
    }
  
    function matchesSubmitButton(element) {
      var target = element;
  
      while (target && target !== document) {
        if (
          elementMatches(target, 'button[type="submit"]') ||
          elementMatches(target, 'input[type="submit"]') ||
          elementMatches(target, 'button:not([type])') ||
          elementMatches(target, '#AddToCart') ||
          elementMatches(target, '[name="add"]')
        ) {
          return true;
        }
  
        target = target.parentNode;
      }
  
      return false;
    }
  
    function attachFormHandlers(form) {
      if (!form || form._mfEngravingFormBound) {
        return;
      }
  
      form._mfEngravingFormBound = true;
  
      form.addEventListener('submit', function () {
        prepareFormForSubmit(form);
      }, true);
  
      form.addEventListener('click', function (event) {
        if (matchesSubmitButton(event.target)) {
          prepareFormForSubmit(form);
        }
      }, true);
  
      form.addEventListener('formdata', function (event) {
        getFieldControls(form).forEach(function (control) {
          var wrapper = getWrapperFromControl(control);
          var config = parseConfig(wrapper);
          var markerValue = getMarkerValue(control, config);

          if (markerValue.trim()) {
            event.formData.set(getHiddenPropertyName(control), markerValue);
          }
        });
      });
    }
  
    function findControl(wrapper) {
      return wrapper.querySelector('textarea' + CONTROL_SELECTOR) ||
        wrapper.querySelector('input' + CONTROL_SELECTOR);
    }
  
    function getPreviewInsertionControl(wrapper) {
      return wrapper
        ? findControl(wrapper) ||
          wrapper.querySelector('textarea' + CONTROL_SELECTOR) ||
          wrapper.querySelector('textarea') ||
          wrapper.querySelector('input' + CONTROL_SELECTOR) ||
          wrapper.querySelector('input')
        : null;
    }
  
    function getDirectChildUnderWrapper(wrapper, element) {
      var node = element;
  
      while (node && node.parentNode && node.parentNode !== wrapper) {
        node = node.parentNode;
      }
  
      return node && node.parentNode === wrapper ? node : null;
    }
  
    function containsElement(parent, child) {
      var node = child;
  
      while (node) {
        if (node === parent) {
          return true;
        }
  
        node = node.parentNode;
      }
  
      return false;
    }
  
    function getPreviewInsertionTarget(wrapper, control) {
      var target;
  
      if (!wrapper || !control) {
        return null;
      }
  
      target = closestElement(control, '.mw-stack__item');
      if (target && containsElement(wrapper, target)) {
        return target;
      }
  
      target = closestElement(control, '.mw-option__container');
      if (target && containsElement(wrapper, target)) {
        return target;
      }
  
      return getDirectChildUnderWrapper(wrapper, control);
    }
  
    function insertPreviewElement(wrapper, element) {
      var control = getPreviewInsertionControl(wrapper);
      var target = getPreviewInsertionTarget(wrapper, control);
      var nextSibling;
  
      if (!wrapper || !element) {
        return;
      }
  
      if (target && target.parentNode) {
        nextSibling = target.nextSibling;
  
        if (
          element.classList &&
          element.classList.contains(PREVIEW_CLASS) &&
          nextSibling &&
          nextSibling.classList &&
          nextSibling.classList.contains(PREVIEW_LABEL_CLASS)
        ) {
          nextSibling = nextSibling.nextSibling;
        }
  
        target.parentNode.insertBefore(element, nextSibling);
        return;
      }
  
      wrapper.appendChild(element);
    }
  
    function getInternalPreview(wrapper) {
      return wrapper ? wrapper.querySelector('.' + PREVIEW_CLASS) : null;
    }
  
    function getExternalPreview(wrapper) {
      var preview = wrapper ? wrapper.nextElementSibling : null;
  
      if (preview && preview.classList.contains(PREVIEW_LABEL_CLASS)) {
        preview = preview.nextElementSibling;
      }
  
      return preview && preview.classList.contains(PREVIEW_CLASS) ? preview : null;
    }
  
    function getExistingPreview(wrapper) {
      return getInternalPreview(wrapper) || getExternalPreview(wrapper);
    }
  
    function movePreviewIntoWrapper(wrapper, preview) {
      var label = getPreviewLabel(preview);
  
      if (!wrapper || !preview || closestElement(preview, FIELD_SELECTOR) === wrapper) {
        return;
      }
  
      if (label) {
        insertPreviewElement(wrapper, label);
      }
  
      insertPreviewElement(wrapper, preview);
    }
  
    function getWrapperFromPreview(preview) {
      var internalWrapper = closestElement(preview, FIELD_SELECTOR);
      var wrapper = preview ? preview.previousElementSibling : null;
  
      if (internalWrapper) {
        return internalWrapper;
      }
  
      if (wrapper && wrapper.classList.contains(PREVIEW_LABEL_CLASS)) {
        wrapper = wrapper.previousElementSibling;
      }
  
      return elementMatches(wrapper, FIELD_SELECTOR) ? wrapper : null;
    }
  
    function findOrCreatePreviewLabel(wrapper, preview) {
      var label = getPreviewLabel(preview);
  
      if (label) {
        return label;
      }
  
      label = document.createElement('div');
      label.className = PREVIEW_LABEL_CLASS;
  
      if (preview) {
        preview.insertAdjacentElement('beforebegin', label);
      } else {
        insertPreviewElement(wrapper, label);
      }
  
      return label;
    }
  
    function findOrCreatePreview(wrapper) {
      var preview = getExistingPreview(wrapper);
  
      if (preview) {
        findOrCreatePreviewLabel(wrapper, preview);
        movePreviewIntoWrapper(wrapper, preview);
        return preview;
      }
  
      preview = document.createElement('div');
      preview.className = PREVIEW_CLASS;
      preview.setAttribute('aria-live', 'polite');
      preview.innerHTML = '<span class="' + PREVIEW_TEXT_CLASS + '"></span>';
      findOrCreatePreviewLabel(wrapper, null);
      insertPreviewElement(wrapper, preview);
      return preview;
    }
  
    function handleControlEdit(control) {
      var wrapper = getWrapperFromControl(control);
      var preview = control._mfEngravingPreview;
      var config = parseConfig(wrapper);
  
      if (!wrapper || !preview) {
        return;
      }
  
      if (control.tagName !== 'TEXTAREA' && control.dataset.mfEngravingSubmitting !== 'true') {
        applyControlLimits(control, config);
      }
  
      renderPreview(control, preview, config);
    }
  
    function bindControl(control) {
      if (
        isTextareaEnhancementDisabled(control) ||
        control._mfEngravingControlBound
      ) {
        return;
      }
  
      control._mfEngravingControlBound = true;
  
      control.addEventListener('input', function () {
        handleControlEdit(control);
      });
  
      control.addEventListener('change', function () {
        handleControlEdit(control);
      });
  
      control.addEventListener('focus', function () {
        if (control.value.indexOf(NEWLINE_MARKER) !== -1) {
          restoreControlForEditing(control);
        }
      });
    }
  
    function bindTextareaPreviewControl(control) {
      if (control._mfEngravingTextareaPreviewBound) {
        return;
      }
  
      control._mfEngravingTextareaPreviewBound = true;
  
      ['focus', 'touchstart', 'pointerdown', 'select'].forEach(function (eventName) {
        control.addEventListener(eventName, function () {
          markTextareaInteraction(control);
        });
      });
  
      control.addEventListener('blur', function () {
        clearTextareaInteraction(control);
      });
  
      control.addEventListener('beforeinput', function (event) {
        handleTextareaBeforeInput(control, event);
      }, true);
  
      control.addEventListener('input', function () {
        var wrapper = getWrapperFromControl(control);
        var config = parseConfig(wrapper);
  
        markTextareaInteraction(control);
        applyControlLimits(control, config);
  
        if (wrapper) {
          renderTextareaState(control, config);
        }
      }, true);
    }
  
    function initializeField(wrapper) {
      var control = findControl(wrapper);
      var preview;
      var config;
  
      if (!control) {
        return;
      }
  
      if (isTextareaEnhancementDisabled(control)) {
        return;
      }
  
      config = parseConfig(wrapper);
  
      if (control.tagName === 'TEXTAREA' && isTextareaInteractionActive(control)) {
        preview = getExistingPreview(wrapper);
        bindTextareaPreviewControl(control);
        attachFormHandlers(closestElement(control, 'form'));
  
        if (preview) {
          control._mfEngravingWrapper = wrapper;
          control._mfEngravingPreview = preview;
        }
  
        return;
      }
  
      preview = findOrCreatePreview(wrapper);
  
      control._mfEngravingWrapper = wrapper;
      control._mfEngravingPreview = preview;
  
      if (control.tagName === 'TEXTAREA') {
        if (!isTextareaInteractionActive(control)) {
          syncControlMaxLength(control, config);
        }
  
        bindTextareaPreviewControl(control);
        attachFormHandlers(closestElement(control, 'form'));
        if (!isTextareaInteractionActive(control)) {
          growTextareaAfterInput(control);
          renderPreview(control, preview, config);
        }
        return;
      }
  
      syncControlMaxLength(control, config);
      bindControl(control);
      attachFormHandlers(closestElement(control, 'form'));
      if (control.tagName !== 'TEXTAREA') {
        applyControlLimits(control, config);
      }
      renderPreview(control, preview, config);
    }
  
    function initializeAllFields() {
      var wrappers = document.querySelectorAll(FIELD_SELECTOR);
      var textControlInteractionActive = isAnyTextControlInteractionActive();
  
      updateSubmitButtonForCartEdit();
      Array.prototype.forEach.call(document.querySelectorAll(PRODUCT_FORM_SELECTOR), attachFormHandlers);
      initializeFontControls(document);
      Array.prototype.forEach.call(wrappers, initializeField);
  
      if (!textControlInteractionActive) {
        restoreCartEditFields();
      }
    }
  
    function installObserver() {
      var timeoutId = null;
      var observer;
  
      if (state.observerInstalled || !window.MutationObserver || !document.body) {
        return;
      }
  
      observer = new MutationObserver(function () {
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(initializeAllFields, OBSERVER_DEBOUNCE_MS);
      });
  
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
  
      state.observerInstalled = true;
    }
  
    function installResizeHandler() {
      if (state.resizeInstalled) {
        return;
      }
  
      window.addEventListener('resize', function () {
        if (isAnyTextControlInteractionActive()) {
          return;
        }
  
        var previews = document.querySelectorAll('.' + PREVIEW_CLASS);
  
        Array.prototype.forEach.call(previews, function (preview) {
          var textNode = preview.querySelector('.' + PREVIEW_TEXT_CLASS);
          var config = parseConfig(getWrapperFromPreview(preview));
  
          if (textNode) {
            fitPreviewText(textNode, preview, config);
          }
        });
      });
  
      state.resizeInstalled = true;
    }
  
    function installTextareaFocusReleaseHandler() {
      var scheduled = false;
      var visualViewport = window.visualViewport;
  
      function scheduleRelease() {
        if (scheduled) {
          return;
        }
  
        scheduled = true;
        requestFrame(function () {
          scheduled = false;
          releaseFocusedTextareaIfOffscreen();
        });
      }
  
      if (state.textareaFocusReleaseInstalled) {
        return;
      }
  
      window.addEventListener('scroll', scheduleRelease, { passive: true });
      window.addEventListener('resize', scheduleRelease);
  
      if (visualViewport && typeof visualViewport.addEventListener === 'function') {
        visualViewport.addEventListener('resize', scheduleRelease);
        visualViewport.addEventListener('scroll', scheduleRelease);
      }
  
      state.textareaFocusReleaseInstalled = true;
    }
  
    function boot() {
      applyPlatformClass();
      addStyles();
      updateSubmitButtonForCartEdit();
      installCartEditUserTouchGuard();
      initializeAllFields();
      ensureCartEditReapplyLoop();
      installObserver();
      installResizeHandler();
      installTextareaFocusReleaseHandler();
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();
  